import { Builder } from 'xml2js'

export function objToXml(objInXml2jsFormat: any): string {
  return new Builder().buildObject(objInXml2jsFormat).replace(/^<\?xml .*\?>\n*/, '')
}

export function removeMarkTags(str: string | undefined) {
  return (str || '').replace(/<\/?mark>/gi, '')
}
